import { render, staticRenderFns } from "./ProductsHistorical.vue?vue&type=template&id=101365f2&scoped=true"
import script from "./ProductsHistorical.vue?vue&type=script&lang=js"
export * from "./ProductsHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101365f2",
  null
  
)

export default component.exports